import { ActionIcon, Button, Menu } from '@mantine/core';
import { Link } from 'react-router';
import { ANLAM } from '../theme';

/**
 * SATIR EYLEMLERİ (P2 · P2-a — Kapsam §20.3b).
 *
 * **SATIRDA BİR BİRİNCİL EYLEM + ⋮ MENÜSÜ.** Her ekran birincilini kendi
 * seçer ama satırda **yalnız bir tane** olur: modüller büyüdükçe her satır
 * beş altı eylem taşıyacak ve hepsi görünürse **önemli olanla önemsiz olan
 * aynı ağırlıkta** durur.
 *
 * ⚠️ **GERİ ALINAMAYAN EYLEM SATIRDA DURMAZ** (P2-a): sil · iptal · arşivle
 * `digerleri` içindedir ve `tehlikeli: true` taşır. Satırda kırmızı bir "Sil"
 * **tek tık uzaktadır**; menüye inince **kasıtlı bir adım** gerektirir. Bu
 * bileşen `tehlikeli` eylemi birincil olarak kabul ETMEZ — tip düzeyinde
 * ayrıdır, böylece kural yanlışlıkla delinemez.
 */
export interface SatirEylemi {
  readonly etiket: string;
  readonly onClick: () => void;
  readonly gizli?: boolean;
  readonly pasif?: boolean;
  /** Geri alınamaz (sil · iptal · arşivle) — YALNIZ ⋮ altında çizilir. */
  readonly tehlikeli?: boolean;
  readonly testId?: string;
}

/** Birincil eylem bir BAĞLANTI da olabilir (orta tıklanabilir olmalı). */
export interface BirincilEylem {
  readonly etiket: string;
  readonly to?: string;
  readonly onClick?: () => void;
  readonly pasif?: boolean;
  readonly testId?: string;
}

export function SatirEylemleri({
  birincil,
  digerleri = [],
  testId,
}: {
  birincil?: BirincilEylem;
  digerleri?: readonly SatirEylemi[];
  testId?: string;
}): React.JSX.Element {
  const gorunur = digerleri.filter((eylem) => !eylem.gizli);
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }} data-testid={testId}>
      {birincil &&
        (birincil.to ? (
          <Button
            component={Link}
            to={birincil.to}
            size="xs"
            variant="light"
            data-testid={birincil.testId}
          >
            {birincil.etiket}
          </Button>
        ) : (
          <Button
            size="xs"
            variant="light"
            onClick={birincil.onClick}
            disabled={birincil.pasif}
            data-testid={birincil.testId}
          >
            {birincil.etiket}
          </Button>
        ))}
      {gorunur.length > 0 && (
        <Menu position="bottom-end" withinPortal>
          <Menu.Target>
            <ActionIcon
              variant="subtle"
              size="sm"
              aria-label="Diğer eylemler"
              data-testid={testId ? `${testId}-menu` : undefined}
            >
              ⋮
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            {gorunur.map((eylem) => (
              <Menu.Item
                key={eylem.etiket}
                onClick={eylem.onClick}
                disabled={eylem.pasif}
                // Renk anlamdan gelir; ekran hex/renk adı sabitlemez.
                color={eylem.tehlikeli ? ANLAM.engel : undefined}
                data-testid={eylem.testId}
              >
                {eylem.etiket}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      )}
    </div>
  );
}
